import React, { useEffect, useMemo, useState } from "react";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { useParams } from "react-router-dom";
import StatsData from "./StatsData";
import GroupsTab from "./GroupsTab";
import UserTab from "./UserTab";
import { GET_GROUP_DETAILS_FROM_UNO } from "../../../apiclient/apiEndpoints";
import apiclient from "../../../apiclient";
import GroupAndUserDisplayCard from "../../../components/common/GroupAndUserDisplayCard";
import { DateRange, debounce } from "../../../utils/general";
import { getFilter } from "../../../utils/filters";
import { useSelector } from "react-redux";
import { FilterIcon } from "../../../assets/icons/icons";
import { DASHBOADTAB, USERSTAB, GROUPSTAB } from "../../../constant/tabTitle";
import HeaderMobile from "../../../components/layout/HeaderMobile";

const { PeriodicRangeFilter, SearchBar, FilterTab } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const Dashboard = ({ isMobileView }) => {
  const [activeTab, setActiveTab] = useState(DASHBOADTAB);
  const { uuid } = useParams();
  const [activeRange, setActiveRange] = useState("all");
  const [uiSearch, setUiSearch] = useState("");
  const [search, setSearch] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [groupDetail, setGroupDetail] = useState({});
  const configData = useUnoSelector((state) => state.config);
  const UNO_URL = configData?.config?.UNO_URL;

  const configSlice = useSelector((state) => state.configSlice);
  const [showfilter, setShowFilter] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState([]);
  const filterOptions = getFilter({ key: activeTab, configSlice: configSlice });

  const tabTitles = [
    { value: "Dashboard", title: DASHBOADTAB },
    { value: `Groups${groupDetail?._count?.children ? ` (${groupDetail?._count?.children})` : ""}`, title: GROUPSTAB },
    { value: `Users${groupDetail?._count?.users ? ` (${groupDetail?._count?.users})` : ""}`, title: USERSTAB },
  ];

  const fetchGroupDetails = async () => {
    try {
      setLoadingData(true);
      const groupDetail = await apiclient.get(`${UNO_URL}${GET_GROUP_DETAILS_FROM_UNO}/${uuid}`);
      const details = {
        avatar: groupDetail?.avatar,
        username: groupDetail?.name,
        identifier: groupDetail?.identifier,
        ...groupDetail,
      };
      setGroupDetail(details);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingData(false);
    }
  };

  const handleSelectedFilter = (e) => {
    setSelectedFilter((prev) => {
      const map = {};
      prev = [...prev, e];
      prev.forEach((item) => (map[item.name] = (map[item.name] || 0) + 1));
      return prev.filter((item) => map[item.name] == 1);
    });
  };

  const resetState = () => {
    setActiveTab(() => DASHBOADTAB);
    setGroupDetail(() => {});
  };

  useEffect(() => {
    resetState();
    fetchGroupDetails();
  }, [uuid]);

  const debouncedFunc = useMemo(() => debounce(setSearch, 600), []);

  return (
    <>
      {isMobileView && <HeaderMobile />}
      <div className="dashboard forTeam">
        {<GroupAndUserDisplayCard loadingData={loadingData} details={groupDetail} uuid={uuid} isMobileView={isMobileView}/>}

        <div className={`dashboardFilters ${activeTab === DASHBOADTAB && "plain"} `}>
          <div className="tabmenus">
            {tabTitles.map((item, i) => (
              <div
                className={`tabItem ${activeTab === item?.title && "active"}`}
                key={i}
                onClick={() => {
                  setSelectedFilter([]);
                  setSearch("");
                  setUiSearch("");
                  setActiveTab(item?.title);
                }}
              >
                {item.value}
              </div>
            ))}
          </div>

          {!loadingData && (
            <div className="filterSearch">
              {/* {activeTab === DASHBOADTAB && (
                <PeriodicRangeFilter
                  filterRange={DateRange}
                  activeRange={activeRange}
                  setActiveRange={(e) => setActiveRange(e)}
                  isMobileView={isMobileView}
                />
              )} */}

              {(activeTab === USERSTAB || activeTab === GROUPSTAB) && (
                <>
                  <SearchBar
                    value={uiSearch}
                    onChange={(e) => {
                      setUiSearch(e.target.value);
                      debouncedFunc(e.target.value, 600);
                    }}
                    placeholder="Search..."
                  />
                  <div className="filterbtn" onClick={() => setShowFilter(true)}>
                    <div className="btninadjust">
                      <FilterIcon />
                      {selectedFilter?.length > 0 && <span className="filter-active-span">{""}</span>}
                    </div>
                  </div>
                  <FilterTab
                    showfilter={showfilter}
                    selectedCheckboxes={selectedFilter || []}
                    filterOptions={filterOptions || []}
                    onToggleFilter={() => setShowFilter(false)}
                    setSelectedCheckboxes={handleSelectedFilter}
                    handleResetCheckBox={() => setSelectedFilter([])}
                  />
                </>
              )}
            </div>
          )}
        </div>

        <div className="tabContent">
          {activeTab === DASHBOADTAB && (
            <div className="dashboardContent">
              <StatsData isMobileView={isMobileView} UUID={uuid} activeRange={activeRange} />
            </div>
          )}
          {activeTab === GROUPSTAB && <GroupsTab  isMobileView={isMobileView} UUID={uuid} querySearch={search} selectedFilter={selectedFilter} />}
          {activeTab === USERSTAB && <UserTab UUID={uuid} querySearch={search} selectedFilter={selectedFilter} />}
        </div>
      </div>
    </>
  );
};

export default Dashboard;
